// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const heracross_mega: PokeData = {
  "id": 10047,
  "name": "heracross-mega",
  "height": 17,
  "weight": 625,
  "base_experience": 210,
  "types": [
    PokeType.BUG,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "horn-attack",
    "fury-attack",
    "tackle",
    "take-down",
    "pin-missile",
    "leer",
    "counter",
    "reversal",
    "endure",
    "megahorn",
    "brick-break",
    "arm-thrust",
    "bullet-seed",
    "aerial-ace",
    "feint",
    "close-combat",
    "night-slash",
    "chip-away"
  ],
  "moves": [
    "tackle",
    "pin-missile",
    "leer",
    "bullet-seed",
    "aerial-ace",
    "close-combat",
    "night-slash",
    "pin-rush",
    "bug-buzz",
    "infest",
    "lunge",
    "drain-punch",
    "string-shot"
  ],
  "evolution_chain": {
    "id": 108,
    "item": null,
    "species": [
      {
        "name": "heracross",
        "order": 244,
        "types": [
          PokeType.BUG,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 107,
    "speed": 85,
    "ability_power": 208
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
